import {labelXml} from "./dymoLabelConstants";

export const NO_PRINTERS_FOUND = "No DYMO printers found";
export const PRINTER_NOT_CONNECTED = "Not Connected";
export const PRINTER_CONNECTED = "Connected";

export function getPrinterName(printersXMLString: string) {
    const cleanedXmlString = printersXMLString.replace(/\\\//g, "/");
    const printerName = cleanedXmlString.match(/<Name>(.*?)<\/Name>/);
    return printerName ? printerName[1]  : NO_PRINTERS_FOUND;
}

export function getPrinterConnectionStatus(printersXMLString: string): string {
    const cleanedXmlString = printersXMLString.replace(/\\\//g, "/");
    const connectionStatus = cleanedXmlString.match(/<IsConnected>(.*?)<\/IsConnected>/g);
    if (connectionStatus) {
        for (const match of connectionStatus) {
            const value = match.match(/<IsConnected>(.*?)<\/IsConnected>/)?.[1];
            if (value === "True") {
                return PRINTER_CONNECTED;
            }
        }
    }
    return PRINTER_NOT_CONNECTED;
}

export function getUpdatedLabelXml({
    dynamicBarcodeText = "NA",
    dynamicMainTitle = "NA",
    dynamicDetails = "NA",
}: { dynamicBarcodeText?: string; dynamicMainTitle?: string; dynamicDetails?: string }) {
    let label = xmlUpdater(labelXml, "BarcodeObject", "Barcode", "Text", dynamicBarcodeText);
    label = xmlUpdater(label, "AddressObject", "MainTitle", "String", dynamicMainTitle);
    label = xmlUpdater(label, "AddressObject", "Details", "String", dynamicDetails + dynamicBarcodeText);
    return label;
}

const xmlUpdater= (xml: string, targetName: string, targetText: string, targetTag: string, newText: string) => {

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xml, "application/xml");

    const targetObjects = xmlDoc.getElementsByTagName(targetName);

    for (let i = 0; i < targetObjects.length; i++) {
        const nameElement = targetObjects[i].getElementsByTagName("Name")[0];
        if (nameElement && nameElement.textContent === targetText) {
            const textElement = targetObjects[i].getElementsByTagName(targetTag)[0];
            if (textElement) {
                textElement.textContent = newText;
            }
        }
    }

    const serializer = new XMLSerializer();
    const updatedXml = serializer.serializeToString(xmlDoc);

    return(updatedXml);
}